<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="40vw"
    :fullscreen="isMobile"
    transition="dialog-bottom-transition"
  >
    <signature-pad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />

    <v-card>
      <v-toolbar v-if="!isMobile" color="primary" dark>{{
        titleForm
      }}</v-toolbar>
      <v-toolbar v-if="isMobile" dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleForm }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text :disabled="disabled" @click="financeBtn.action">
            <div class="text-caption text-sm-body-1">
              {{ financeBtn.name }}
            </div>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text
        :style="{
          height: isMobile ? '82vh' : '',
        }"
      >
        <v-row class="mt-3">
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="month"
                  label="Month"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="date"
                :active-picker.sync="monthPicker"
                @change="saveMonth"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="financeDate"
                  label="Day"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="rules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="financeDate"
                :active-picker.sync="dayPicker"
                :max="newMaxDate"
                :min="newMinDate"
                @change="validateDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="mt-3">
          <v-col cols="12" md="12">
            <v-text-field
              :value="signedPBAFile ? signedPBAFile[0].name : ''"
              label="Signed PBA Documentation"
              prepend-icon="mdi-paperclip"
              outlined
              readonly
              @click="$refs.signedPBAInput.click()"
            />
            <input
              ref="signedPBAInput"
              type="file"
              style="display: none"
              @change="fileSelectSigned"
            />

            <v-card class="pa-3 mb-2" v-if="signedPBAFile">
              <div v-for="(item, i) in signedPBAFile" :key="i">
                <div class="d-flex justify-space-between align-center mb-2">
                  <h4 class="text-h6">Signed PBA Documentation</h4>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click="deleteSignedPBA(item)"
                    title="Delete Signed PBA"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <v-img
                  :src="item.aws"
                  :lazy-src="item.aws"
                  height="300"
                  contain
                  v-if="imageFileTypes.includes(item.ext)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <v-chip
                  v-if="item.ext != 'pdf' && !imageFileTypes.includes(item.ext)"
                  class="ma-2"
                  color="pink"
                  label
                  text-color="white"
                >
                  <v-icon left> mdi-label </v-icon>
                  <a :href="item.aws" class="white--text">{{ item.name }}</a>
                </v-chip>

                <div v-if="item.ext == 'pdf'">
                  <LoadPDF :pdfFile="item.aws" :pdfName="item.name" />
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="12">
            <v-text-field
              :value="unsignedPBAFile ? unsignedPBAFile[0].name : ''"
              label="Unsigned PBA Documentation"
              prepend-icon="mdi-paperclip"
              outlined
              readonly
              @click="$refs.unsignedPBAInput.click()"
            />
            <input
              ref="unsignedPBAInput"
              type="file"
              style="display: none"
              @change="fileSelectUnsigned"
            />

            <v-card class="pa-3 mb-2" v-if="unsignedPBAFile">
              <div v-for="(item, i) in unsignedPBAFile" :key="i">
                <div class="d-flex justify-space-between align-center mb-2">
                  <h4 class="text-h6">Unsigned PBA Documentation</h4>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click="deleteUnsignedPBA(item)"
                    title="Delete Unsigned PBA"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <v-img
                  :src="item.aws"
                  height="300"
                  contain
                  v-if="imageFileTypes.includes(item.ext)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <v-chip
                  v-if="item.ext != 'pdf' && !imageFileTypes.includes(item.ext)"
                  class="ma-2"
                  color="pink"
                  label
                  text-color="white"
                >
                  <v-icon left> mdi-label </v-icon>
                  <a :href="item.aws" class="white--text">{{ item.name }}</a>
                </v-chip>

                <div v-if="item.ext == 'pdf'">
                  <LoadPDF :pdfFile="item.aws" :pdfName="item.name" />
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- <v-row class="mt-1">
          <v-col cols="12" md="12">
            <v-text-field
              label="Amount"
              prefix="$"
              v-model="newAmount"
              outlined
              type="number"
            ></v-text-field>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12" md="12">
            <!-- <v-checkbox
              label="Opened By"
              hide-details
              @change="addSignature($event)"
              v-model="checkedSignature"
            ></v-checkbox> -->
            <v-text-field
              label="Opened By"
              v-model="staffSignature"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
        <div>
          <v-img
            max-height="80"
            max-width="150"
            :src="staffDigitalSignature"
            contain
          ></v-img>
        </div>
      </v-card-text>

      <v-card-text v-if="closeOut">
        <v-alert border="top" colored-border type="info" elevation="2">
          You're about to rollover balance:<br />
          <!-- {{ month }} to {{ currentMonth }} -->
          <div class="d-flex text-center">
            <v-card
              class="d-flex pa-2 ma-5"
              outlined
              rounded="lg"
              color="#8C000D"
              min-width="70px"
            >
              <div class="pa-3 text-center">
                <div>
                  <h3 class="font-weight-medium white--text">EBT</h3>
                  <span class="subtitle-1 white--text">
                    {{ financeSideData.EBT }}
                  </span>
                  <br />
                </div>
              </div>
            </v-card>
            <v-card
              class="d-flex pa-2 ma-5"
              outlined
              rounded="lg"
              color="#0B3866"
              min-width="70px"
              flat
            >
              <div class="pa-3">
                <div>
                  <h3 class="font-weight-medium white--text">DC</h3>
                  <span class="subtitle-1 white--text">
                    {{ financeSideData.DebitCard }}
                  </span>
                  <br />
                </div>
              </div>
            </v-card>
            <v-card
              class="d-flex pa-2 ma-5"
              outlined
              rounded="lg"
              color="#52A65E"
              min-width="70px"
            >
              <div class="pa-3">
                <div>
                  <h3 class="font-weight-medium white--text">Cash</h3>
                  <span class="subtitle-1 white--text">
                    {{ financeSideData.Cash }}
                  </span>
                  <br />
                </div>
              </div>
            </v-card>
          </div>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="white--text"
          color="primary"
          @click.stop="showSignaturePad = true"
        >
          <div class="text-caption text-sm-body-1">Staff Signature</div>
        </v-btn>

        <v-spacer v-if="isMobile"></v-spacer>

        <div class="ml-5" v-show="editFinance">
          <v-switch inset v-model="closeOut" label="Closeout"></v-switch>
        </div>

        <v-spacer></v-spacer>
        <v-btn
          v-if="!isMobile"
          size="large"
          :disabled="disabled"
          class="white--text"
          :color="financeBtn.color"
          @click="financeBtn.action"
        >
          <div class="text-caption text-sm-body-1">
            {{ financeBtn.name }}
          </div>
        </v-btn>
        <v-btn v-if="!isMobile" color="blue darken-1" text @click="close">
          <div class="text-caption text-sm-body-1">Cancel</div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import SignaturePad from "@/components/SignaturePad";
import LoadPDF from "@/components/LoadPDF.vue";
import { mapActions, mapGetters } from "vuex";
import { setUserTz, setUserSignatureTz, tz } from "../../../utils/timezone";
import renameFileHelper from "@/mixins/renameFileHelper";
import moment from "moment";
const url = require("../../client_config/config").url;

export default {
  mixins: [renameFileHelper],

  props: {
    financeItemData: {
      type: Array,
      default: () => [],
    },
    clientID: {
      type: String,
    },
  },
  components: {
    SignaturePad,
    LoadPDF,
  },
  data() {
    return {
      monthPicker: null,
      dayPicker: null,
      date: null,
      menu: false,
      menu1: false,
      month: null,
      day: null,
      editFinance: false,
      titleForm: "New Monthly Register",
      financeID: "",
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      signed: false,
      showSignaturePad: false,
      checkedSignature: false,
      rules: [],
      disabled: false,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      newMinDate: null,
      newMaxDate: null,
      minDate: "",
      maxDate: "",
      financeDate: "",
      closeOut: false,
      signedPBA: [],
      unsignedPBA: [],
      signedPBAdoc: "",
      unsignedPBAdoc: "",
      staffDigitalSignature: "",
      staffSignature: "",
      signedPBAFile: null,
      unsignedPBAFile: null,
      imageFileTypes: ["JPEG", "PNG", "JPG", "png", "jpg", "jpeg"],
      isSaving: false,
      staff: localStorage.getItem("Name"),
      rolloverMsg: "",
      currentMonth: moment().format("MMMM"),
      month: "",
    };
  },

  computed: {
    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getFinanceData: "finances/finances",
    }),

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    clientName() {
      // Try to get client name from store first
      if (this.$store.state.finances.items && this.$store.state.finances.items[0] && this.$store.state.finances.items[0].ClientName) {
        return this.$store.state.finances.items[0].ClientName;
      }
      // Fallback to "Unknown" if not available
      return "Unknown";
    },

    financeSideData() {
      let initialValue = parseFloat(0).toFixed(2);

      const filterFinances = this.financeItemData.find(
        (item) => item._id === this.financeID
      );

      let Cash = parseFloat(filterFinances?.Cash?.$numberDecimal).toFixed(2);
      let EBT = parseFloat(filterFinances?.EBT?.$numberDecimal).toFixed(2);
      let DebitCard = parseFloat(
        filterFinances?.DebitCard?.$numberDecimal
      ).toFixed(2);

      return {
        Cash: isNaN(Cash) ? initialValue : Cash,
        EBT: isNaN(EBT) ? initialValue : EBT,
        DebitCard: isNaN(DebitCard) ? initialValue : DebitCard,
      };
    },

    financeBtn() {
      let state = "";
      if (this.editFinance) {
        state = {
          name: "Update",
          color: "blue darken-1",
          action: this.onUpdateItem,
        };
      }
      if (!this.editFinance) {
        state = {
          name: "Save",
          color: "#259647",
          action: this.onAddItem,
        };
      }

      /*
      if (this.editFinance && this.closeOut) {
        state = {
          name: "closeout and transfer",
          color: "blue darken-1",
          action: this.closeOutAndTransfer,
        };
      }

      if (this.editFinance && this.closeOut && !this.isCurrentMoment) {
        state = {
          name: "clouseout",
          color: "blue darken-1",
          action: this.onUpdateStatus,
        };
      }
      */

      if (this.isSaving) {
        state = {
          name: "Saving....",
          color: "",
          action: "",
        };
      }
      return state;
    },

    dialog: {
      get() {
        return this.$store.state.finances.monthlyAmountDialog;
      },
      set(val) {
        this.$store.commit("finances/SET_MONTHLY_AMOUNT_DIALOG", val);
      },
    },

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    userSignatureTz() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserSignatureTz(data);
    },
  },

  created() {
    this.staffSignature = `${this.staff} - ${new Date()}`;
  },

  methods: {
    ...mapActions("finances", [
      "addFinance",
      "updateFinance",
      "addFinanceFromRollOver",
    ]),

    saveMonth(date) {
      this.newMinDate = tz(date, this.userTimezone)
        .startOf("month")
        .format("YYYY-MM-DD");

      this.newMaxDate = tz(date, this.userTimezone)
        .endOf("month")
        .format("YYYY-MM-DD");

      const newDate = tz(date, this.userTimezone);

      this.month = this.monthNames[newDate.month()];

      this.financeDate = tz(date, this.userTimezone)
        .startOf("month")
        .format("YYYY-MM-DD");

      this.$refs.menu.save(this.financeDate);

      this.validateDate();
    },

    saveDay(date) {
      this.$refs.menu1.save(date);
    },

    onViewItem(item) {
      this.editFinance = true;
      this.financeID = item._id;
      this.closeOut = item.CloseOut;
      this.financeDate = tz(item.Date, this.userTimezone).format("YYYY-MM-DD");
      this.month = item.Month;
      this.staffSignature = item.StaffSignature
        ? ((this.checkedSignature = true), item.StaffSignature)
        : ((this.checkedSignature = false), "");
      this.staffDigitalSignature = item.StaffDigitalSignature;

      this.month = item.Month;
      this.signedPBAFile = this.loadDocument(item.documents?.SignedPBA);
      this.unsignedPBAFile = this.loadDocument(item.documents?.UnsignedPBA);

      this.minDate = moment(new Date(item.Date))
        .startOf("month")
        .format("YYYY-MM-DD");
      this.maxDate = moment(new Date(item.Date))
        .endOf("month")
        .format("YYYY-MM-DD");

      this.validate(item.Date);
    },

    validate(date) {
      const dateToCheck = moment(date);
      const currentMonth = moment().month();
      const currentYear = moment().year();

      if (
        dateToCheck.month() === currentMonth &&
        dateToCheck.year() === currentYear
      )
        return (this.isCurrentMoment = true);

      return (this.isCurrentMoment = false);
    },

    validateDate() {
      if (this.editFinance) return (this.rules = []);

      const getMonth = (date) => {
        return moment(date).month();
      };

      const getYear = (date) => {
        return moment(date).year();
      };

      let newMonth = getMonth(this.financeDate);
      let newYear = getYear(this.financeDate);

      const date = this.getFinanceData.find((item) => {
        let itemMonth = getMonth(item.Date);
        let itemYear = getYear(item.Date);
        if (newMonth === itemMonth && newYear === itemYear) {
          return true;
        }
      });

      if (date) {
        this.rules = ["Date already added for this month"];
        this.disabled = true;
      } else {
        this.rules = [true];
        this.disabled = false;
      }
    },
    signatureData(data) {
      this.staffDigitalSignature = data;
    },

    async onAddItem() {
      this.isSaving = true;
      this.disabled = true;
      var req_body = {
        Date: this.financeDate,
        Month: this.month,
        StaffSignature: this.staffSignature,
        StaffDigitalSignature: this.staffDigitalSignature,
        CloseOut: this.closeOut,
        ClientID: this.clientID,
      };

      let response = await this.addFinance(req_body);

      if (this.signedPBAdoc !== "" && this.signedPBAdoc !== undefined) {
        await this.uploadSignedDocument(response.data._id);
      }

      if (this.unsignedPBAdoc !== "" && this.unsignedPBAdoc !== undefined) {
        await this.uploadUnsignedDocument(response.data._id);
      }

      if (response.success) {
        this.financeID = response.data._id;
        this.$emit("message-dialog", { text: "Successfully Added", msg: true });
      }

      if (!response.success) {
        this.isSaving = false;
        this.disabled = false;
        return alert(response.message);
      }

      this.isSaving = false;
      this.disabled = false;
      this.close();
      this.$emit("get-finance-transactions");
      this.$emit("get-finance");
    },

    async onUpdateItem() {
      this.isSaving = true;
      this.disabled = true;
      var req_body = {
        Date: this.financeDate,
        Month: this.month,
        StaffSignature: this.staffSignature,
        StaffDigitalSignature: this.staffDigitalSignature,
        ClientID: this.clientID,
        CloseOut: this.closeOut,
      };

      let response = await this.updateFinance({ req_body, id: this.financeID });

      if (this.signedPBAdoc !== "" && this.signedPBAdoc !== undefined) {
        await this.uploadSignedDocument(response.data._id);
      }

      if (this.unsignedPBAdoc !== "" && this.unsignedPBAdoc !== undefined) {
        await this.uploadUnsignedDocument(response.data._id);
      }

      if (response.success) {
        this.financeID = response.data._id;
        this.$emit("message-dialog", {
          text: "Successfully Updated",
          msg: true,
        });
      }

      if (!response.success) {
        this.isSaving = false;
        this.disabled = false;
        return alert(response.message);
      }

      this.isSaving = false;
      this.disabled = false;
      this.$emit("get-finance-transactions");
      this.$emit("get-finance");
      this.close();
    },

    addSignature(e) {
      if (!e) return (this.staffSignature = "");
      this.staffSignature = this.staff + " - " + new Date();
    },

    onUpdateStatus() {
      this.$store
        .dispatch("finances/updateStatus", {
          CloseOut: this.closeOut,
          id: this.financeID,
        })
        .then((res) => {
          this.close();
          this.$emit("message-dialog", { msg: true, text: res.data.message });
          this.$emit("get-finance");
        });
    },

    async closeOutAndTransfer() {
      this.disabled = true;
      let defaultItem = {
        ClientID: this.clientID,
      };

      let rolloverItem = {
        TransactionType: "Deposit",
        DepositCategory: "Rollover",
        Notes: `Rollover balance from ${this.month}`,
      };

      let closeOutItem = {
        TransactionType: "Expense",
        ExpenseCategory: "Rollover",
        Notes: `Rollover balance to ${moment().format("MMMM")} `,
      };

      try {
        let data = {
          newMonthlyRegister: {
            ...defaultItem,
            Date: new Date(),
            Month: moment().format("MMMM"),
            StaffSignature: `${this.staff} - ${new Date()}`,
          },
          updatedMonthlyRegister: { CloseOut: true },
          newFinanceTransaction: {
            ...defaultItem,
            ...rolloverItem,
            Date: new Date(),
          },
          updatedFinanceTransaction: {
            ...defaultItem,
            ...closeOutItem,
            Date: new Date(),
          },
          balances: this.financeSideData,
        };

        const response = await this.addFinanceFromRollOver({
          data,
          id: this.financeID,
        });
        console.log(response);
        this.disabled = false;
        this.close();
        this.$emit("get-finance-transactions");
        this.$emit("get-finance");
      } catch (error) {
        console.log(error);
        this.disabled = false;
      }
    },

    async fileSelectSigned(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        
        let filename = await this.renameFileHelper(
          file,
          this.clientName,
          "signedPBA",
          this.month,
          true
        );
        this.signedPBAdoc = filename;
        this.signedPBA = file; // Store the actual file object
        
        // Update the display data to show the selected file
        this.signedPBAFile = [{
          aws: URL.createObjectURL(file),
          name: file.name,
          ext: file.name.split('.').pop()
        }];
        
        console.log(filename);
      }
    },

    async fileSelectUnsigned(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        
        let filename = await this.renameFileHelper(
          file,
          this.clientName,
          "unsignedPBA",
          this.month,
          true
        );
        this.unsignedPBAdoc = filename;
        this.unsignedPBA = file; // Store the actual file object
        
        // Update the display data to show the selected file
        this.unsignedPBAFile = [{
          aws: URL.createObjectURL(file),
          name: file.name,
          ext: file.name.split('.').pop()
        }];
        
        console.log(filename);
      }
    },

    async uploadSignedDocument(id) {
      if (this.signedPBA) {
        const formData = new FormData();
        formData.append("signed-pba", this.signedPBA);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        await axios.post(
          `${url}/finances/fileuploader/signed/${id}/${this.clientID}`,
          formData,
          ct
        );
      }
    },

    async uploadUnsignedDocument(id) {
      if (this.unsignedPBA) {
        const formData = new FormData();
        formData.append("unsigned-pba", this.unsignedPBA);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        await axios.post(
          `${url}/finances/fileuploader/unsigned/${id}/${this.clientID}`,
          formData,
          ct
        );
      }
    },

    loadDocument(file) {
      if (file && file.link !== undefined && file.name !== undefined) {
        let AWSLink = file.link || "";
        const documentDetails = [];
        let fileExt = AWSLink.split(".").pop();
        documentDetails.push({
          aws: AWSLink,
          name: file.name,
          ext: fileExt,
        });
        return documentDetails;
      }
      return null;
    },

    close() {
      this.dialog = false;
      this.editFinance = false;
      this.disabled = false;
      this.clear();
    },

    clear() {
      this.financeDate = "";
      (this.month = null), (this.signedPBA = null);
      this.unsignedPBA = null;
      this.staffSignature = "";
      this.staffDigitalSignature = "";
      this.closeOut = false;

      this.checkedSignature = false;
      this.minDate = "";
      this.maxDate = "";
      this.newMinDate = "";
      this.newMaxDate = "";
      this.rules = [];

      this.unsignedPBAFile = null;
      this.signedPBAFile = null;
      this.signedPBAdoc = "";
      this.unsignedPBAdoc = "";
      this.staffSignature = `${this.staff} - ${new Date()}`;
      
      if (this.$refs.signedPBAInput) {
        this.$refs.signedPBAInput.value = '';
      }
      if (this.$refs.unsignedPBAInput) {
        this.$refs.unsignedPBAInput.value = '';
      }
    },

    async deleteSignedPBA(item) {
      if (confirm("Are you sure you want to delete this signed PBA documentation?")) {
        try {
          // Get the current finance item to find the document ID
          const currentFinance = this.$store.state.finances.items[0];
          if (currentFinance && currentFinance.SignedPBA) {
            await axios.delete(`${url}/documents/${currentFinance.SignedPBA}`);
            
            // Clear the signed PBA from the finance record
            await axios.put(`${url}/finances/${currentFinance._id}`, {
              SignedPBA: null
            });
            
            // Refresh the data
            this.signedPBAFile = null;
            this.$emit("get-finance");
            this.$emit("message-dialog", {
              msg: true,
              text: "Signed PBA documentation deleted successfully"
            });
          }
        } catch (error) {
          console.error("Error deleting signed PBA:", error);
          this.$emit("message-dialog", {
            msg: true,
            text: "Error deleting signed PBA documentation"
          });
        }
      }
    },

    async deleteUnsignedPBA(item) {
      if (confirm("Are you sure you want to delete this unsigned PBA documentation?")) {
        try {
          // Get the current finance item to find the document ID
          const currentFinance = this.$store.state.finances.items[0];
          if (currentFinance && currentFinance.UnsignedPBA) {
            await axios.delete(`${url}/documents/${currentFinance.UnsignedPBA}`);
            
            // Clear the unsigned PBA from the finance record
            await axios.put(`${url}/finances/${currentFinance._id}`, {
              UnsignedPBA: null
            });
            
            // Refresh the data
            this.unsignedPBAFile = null;
            this.$emit("get-finance");
            this.$emit("message-dialog", {
              msg: true,
              text: "Unsigned PBA documentation deleted successfully"
            });
          }
        } catch (error) {
          console.error("Error deleting unsigned PBA:", error);
          this.$emit("message-dialog", {
            msg: true,
            text: "Error deleting unsigned PBA documentation"
          });
        }
      }
    },
  },
};
</script>